import React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { toWords } from 'number-to-words';
import { hot } from 'react-hot-loader';

function numberWithCommas(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function formatNumberString(x) {
	let str = x.split(' ').map(x => x.charAt(0).toUpperCase() + x.slice(1));
	str = Object.values(str).join(' ');
	str = str.split(',').join(' ');

	return str;
}

function isFloat(n) {
	return Number(n) === n && n % 1 !== 0;
}

function formatInterest(x) {
	if (isFloat(x)) {
		const formatInterest = String(x).split('.');

		return toWords(formatInterest[0]) + ' point ' + toWords(formatInterest[1]);
	} else {
		return toWords(x);
	}
}

function AmountInterest(props) {
	const loanObject = props.loanObject;

	const principal = numberWithCommas(loanObject.principal.toFixed(2));

	const principal_str = loanObject.principal.toString();

	const principal_array_centavos = principal.split('.');
	const principal_array = principal_str.split('.');

	let principal_words = principal_array_centavos[1]
		? formatNumberString(toWords(principal_array[0]))
		: formatNumberString(toWords(principal_array[0]) + ' Pesos ');

	if (principal_array_centavos[1] && principal_array_centavos[1] > 0) {
		// principal_words = principal_words + formatNumberString(toWords(principal_array[1])) + ' Centavos ';

		principal_words = principal_words + ' and ' + principal_array_centavos[1] + '/100' + ' Pesos ';
	}
	const interestWord = formatInterest(loanObject.annual_rate);
	const annual_rate = loanObject.annual_rate;

	return (
		<>
			<Trans i18nKey="loan_agreement.amount_interest">
				<p className="justify">
					<strong>LOAN AMOUNT.</strong> The LENDER has lent the BORROWER the amount of
					{{ principal_words }} ₱ (Php {{ principal }} ) (the “Loan”).
				</p>
				<p className="justify">
					<strong>INTEREST.</strong> This Loan has a monthly interest rate of {{ interestWord }} percent (
					{{ annual_rate }}%), which the BORROWER has promised to pay.
				</p>
			</Trans>
		</>
	);
}

export default hot(module)(withTranslation()(AmountInterest));
